import styles from "./mainPage.module.css";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/layouts/prime.css";
import "./mainPage.css";
import makeAnimated from "react-select/animated";
import CreatableSelect from "react-select/creatable";
import toast, { Toaster } from "react-hot-toast";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

import TodoApp from "./TodoApp/TodoApp";
import ResrvApp from "./RezervTodos/TodoApp/ResrvApp";
import { translateToReactSelect, compareDailyInfo, maskNumber } from "../helperFunctions";
import { useState, useRef, useEffect } from "react";
import { getLeaders, getUserTags, getAttractions, getTourTags, getEssentialsAccessories, getCities, getDailyInfo, saveReservePrograms, saveAdditionalCost, saveTables, saveDailyInfo, saveTourDetails, getTourDetails, getReservePrograms, getTables, getAdditionalCost } from "../../create-tours/APIFunctions";
import { useMeals, useMealsAction } from "../../../Context/MealsProvider";
import { useTables, useTablesAction } from "../../../Context/TablesProvider";
import { useTableFixeds, useTableFixedsAction } from "../../../Context/TableFixedProvider";
import { useTableFinacials, useTableFinacialsAction } from "../../../Context/TableFinancial";
import { useParams } from "react-router-dom";
import { forwardRef, useImperativeHandle } from "react";
import Loader from "utilities/Loader";

const MainPage = forwardRef(({ changeHandlerDaste, catValue, setValue, setDays, days, addDayHandler }, ref) => {
  useImperativeHandle(ref, () => ({
    clickSaveHandler,
  }));
  const params = useParams();
  const tables = useTables();
  const dispatchMeals = useMealsAction();
  const dispatch = useTablesAction();
  const dispatchFixed = useTableFixedsAction();
  const dispatchFinacial = useTableFinacialsAction();
  const meals = useMeals();
  const tableFixed = useTableFixeds();
  const tableFinancial = useTableFinacials();
  const [allOptions, setAllOptions] = useState([]);
  const [todos, setTodos] = useState([]);
  const [todos2, setTodos2] = useState([]);
  const [allLeader, setAllLeader] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [allJazebe, setAllJazebe] = useState([]);
  const [allAccessories, setAllAccessories] = useState([]);
  const [sakhti, setSakhti] = useState("-2");
  const [vaziat, setVaziat] = useState("-1");
  const [nameLeader, setNameLeader] = useState("");
  const [nameCities, setNameCities] = useState("");
  const [valJazebe, setValJazebe] = useState("");
  const [valLavazem, setValLavazem] = useState("");
  const [valueDateStart, setValueDateStart] = useState("");
  const [valueDatePayan, setValueDatePayan] = useState("");
  const [checkedBime, setCheckedBime] = useState(false);
  const [checkedVisa, setCheckedVisa] = useState(false);
  const [checkedVije, setCheckedVije] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [allUserTag, setAllUserTag] = useState([{ label: "", value: "", id: 0 }]);

  const [checkIt, setCheckIt] = useState({
    zamini: false,
    havai: false,
    reili: false,
  });
  const [inputVal, setInputVal] = useState({
    tourName: "",
    tourLeader: "",
    hazine: "",
    mavaredZarur: "",
  });
  const [attrac, setAttrac] = useState({
    pic: null,
  });
  var number = 1234565555555555;
  Number(number).toLocaleString();

  // convertToNumber(number) {
  //   return Number(number).toLocaleString();
  // }
  const tourIdFunc = () => {
    if (params.tour_id) {
      return params.tour_id;
    }
    return -1;
  };
  const [tourId, setTourId] = useState(tourIdFunc);

  let attraction = [];
  for (let item = 0; item < valJazebe.length; item++) {
    if (!allJazebe.some((value) => value.value == valJazebe[item].value)) {
      attraction.push({
        id: -1,
        title: valJazebe[item].label,
      });
    } else {
      attraction.push({
        id: valJazebe[item].value,
        title: valJazebe[item].label,
      });
    }
  }

  let accessories = [];
  for (let item = 0; item < valLavazem.length; item++) {
    accessories.push(valLavazem[item].label);
  }

  const [daste, setDaste] = useState([]);

  useEffect(() => {
    if (catValue) {
      for (let item = 0; item < catValue.length; item++) {
        setDaste([...daste, { id: catValue[item].value, title: catValue[item].label }]);
      }
    }
  }, [catValue]);

  let allTables = [tableFixed, tableFinancial, tables];

  let translatedCatValue = translateToReactSelect(catValue, true);
  for (let index = 0; index < translatedCatValue.length; index++) {
    if (!allOptions.some((value) => value.value == translatedCatValue[index].id)) {
      translatedCatValue[index].id = -1;
    }
  }
  var selectedCity = {};

  if (!allCities.some((value) => value.value == nameCities.value)) {
    selectedCity = { id: -1, title: nameCities.label };
  } else {
    selectedCity = {
      id: nameCities.value,
      title: nameCities.label,
    };
  }
  if (selectedCity.title == undefined) {
    selectedCity = "";
  }
  let infoDetail = {
    id: tourId,
    city: selectedCity,
    title: inputVal.tourName,
    mainprice: inputVal.hazine,
    stm: valueDateStart.valueOf(),
    ftm: valueDatePayan.valueOf(),
    hardshiplevel: sakhti,
    essentials_accessories: accessories,
    visa: getBoolean(checkedVisa),
    insurance: getBoolean(checkedBime),
    tourleaderuid: nameLeader,
    isspecial: getBoolean(checkedVije),
    trip_type: "number",
    essentials: inputVal.mavaredZarur,
    tour_tags: translatedCatValue,
    attractions: attraction,
    main_status: vaziat,
  };

  function getBoolean(item) {
    if (item) return 1;
    return 0;
  }
  // label => title
  // value => id
  const clickSaveHandler = () => {
    let s = "";
    if (checkIt.havai) {
      s += "1";
    }
    if (checkIt.zamini) {
      s += (s.length > 0 ? "+" : "") + "2";
    }
    if (checkIt.reili) {
      s += (s.length > 0 ? "+" : "") + "3";
    }
    infoDetail.trip_type = s;
    infoDetail.essentials_accessories = accessories.join("+");
    console.log("infoDetail", infoDetail);
    console.log("send meals", meals);
    // if (infoDetail.ftm == "" || infoDetail.stm == "" || infoDetail.hardshiplevel == "" || infoDetail.main_status == "" || infoDetail.mainprice == "" || infoDetail.title == "" || infoDetail.tourleaderuid == "" || infoDetail.trip_type == "") {
    //   toast.error("لطفا تمامی فیلدهای ستاره دار (*) را پر کنید!");

    //   return null;
    // }
    setIsLoading(true);

    saveTourDetails(infoDetail).then(async (value) => {
      await setTourId(value);
      await saveReservePrograms(
        value,
        todos.map((val) => {
          return {
            ...val,
            tour_id: value,
            user_tag_id: val.user_tag_id.value,
          };
        })
      );
      await saveAdditionalCost(
        value,
        todos2.map((val) => {
          return { ...val, tour_id: value };
        })
      );
      await saveTables(value, allTables);
      await saveDailyInfo(value, meals);
      setIsLoading(false);
      toast.success("تور با موفقیت ثبت شد!");
    });
  };

  useEffect(() => {
    setIsLoading(true);

    var allUserTagTemp = [];
    (async () => {
      let data = await getUserTags().then((res) => res);

      for (let index = 0; index < data.length; index++) {
        let newObject = {};
        newObject.value = data[index].id;
        newObject.label = data[index].title;
        allUserTagTemp.push(newObject);
      }
      setAllUserTag(allUserTagTemp);
    })();

    const getInfo = async () => {
      let data = await getLeaders().then((res) => res);
      let allLeader = [];
      for (let index = 0; index < data.length; index++) {
        let newObject = {};
        newObject.value = data[index].id;
        newObject.fname = data[index].fname;
        newObject.lname = data[index].lname;
        allLeader.push(newObject);
      }
      setAllLeader(allLeader);
      data = await getCities().then((res) => res);
      let allCities1 = data;
      let allCities = [];
      for (let index = 0; index < data.length; index++) {
        let newObject = {};
        newObject.value = data[index].id;
        newObject.label = data[index].title;
        allCities.push(newObject);
      }
      setAllCities(allCities);
      data = await getAttractions().then((res) => res);
      // setValJazebe(data);

      let allJazebe = [];
      for (let index = 0; index < data.length; index++) {
        let newObject = {};
        newObject.value = data[index].id;
        newObject.label = data[index].title;
        allJazebe.push(newObject);
      }
      setAllJazebe(allJazebe);
      data = await getEssentialsAccessories().then((res) => res);
      let allAccessories1 = [];
      for (let index = 0; index < data.length; index++) {
        let newObject = {};
        newObject.value = index;
        newObject.label = data[index];
        allAccessories1.push(newObject);
      }
      setAllAccessories(allAccessories1);

      data = await getTourTags().then((res) => res);
      //setValue(data);
      let allOptions = [];
      for (let index = 0; index < data.length; index++) {
        let newObject = {};
        newObject.value = data[index].id;
        newObject.label = data[index].title;
        allOptions.push(newObject);
      }
      setAllOptions(allOptions);

      if (tourId != -1) {
        data = await getDailyInfo(tourId);
        console.log("allCities1", allCities1);
        for (let index = 0; index < allCities1.length; index++) {
          if (data[0][12].name == allCities1[index].id) {
            data[0][12].name = {
              title: allCities1[index].title,
              id: allCities1[index].id,
            };
          }
        }

        console.log("getDailyInfo", data);
        // inja bayad shahr mabda check shvad
        addDayHandler(compareDailyInfo(data, "get"));
        dispatchMeals({
          type: "setAsyncData",

          data: data,
        });
      }
      if (tourId != -1) {
        data = await getReservePrograms(tourId);
        loop1: for (let index = 0; index < data.length; index++) {
          let user_tag_id_object = {};
          user_tag_id_object.value = data[index].user_tag_id;

          user_tag_id_object.label = allUserTagTemp.find((value) => {
            return value.value == user_tag_id_object.value;
          })?.label;
          if (user_tag_id_object.label) {
            data[index].user_tag_id = user_tag_id_object;
          }
        }
        setTodos([...data]);
      }
      if (tourId != -1) {
        data = await getAdditionalCost(tourId);

        setTodos2([...data]);
      }
      if (tourId != -1) {
        data = await getTables(tourId);
        dispatchFixed({
          type: "setTableFixed",
          data: data,
        });
        dispatchFinacial({
          type: "setTableEstimate",
          data: data,
        });
        dispatch({
          type: "setTableOther",
          data: data,
        });
      }
      if (tourId != -1) {
        data = await getTourDetails(tourId);
        console.log("get tour detail", data);
        let { trip_type } = data;
        setCheckIt({
          zamini: trip_type.includes("2"),
          havai: trip_type.includes("1"),
          reili: trip_type.includes("3"),
        });
        setCheckedBime(+data.insurance);
        setCheckedVije(+data.isspecial);
        setCheckedVisa(+data.visa);
        setValueDatePayan(+data.ftm);
        setValueDateStart(+data.stm);

        let selectedCity = allCities.find((value) => {
          return value.value == data.cityid;
        });

        setNameCities(selectedCity);

        let selectedJazebe = allJazebe.filter((value) => {
          for (let index = 0; index < data.attractions.length; index++) {
            if (data.attractions[index].tour_attraction_id == value.value) return true;
          }
          return false;
        });

        let selectedDasteBandi = allOptions.filter((value) => {
          for (let index = 0; index < data.tour_tags.length; index++) {
            if (data.tour_tags[index].tour_tag_id == value.value) return true;
          }
          return false;
        });

        // temp
        // data.essentials_accessories = [];
        let selectedAccessories = [];
        for (let index = 0; index < allAccessories1.length; index++) {
          for (let index2 = 0; index2 < data.essentials_accessories.length; index2++) {
            if (allAccessories1[index].label == data.essentials_accessories[index2]) {
              selectedAccessories.push(allAccessories1[index]);
            }
          }
        }
        setValLavazem(selectedAccessories);
        setValue(selectedDasteBandi);
        setValJazebe(selectedJazebe);
        setSakhti(+data.hardshiplevel);
        setVaziat(+data.main_status);
        setNameLeader(+data.tourleaderuid);
        setInputVal((prev) => {
          return { ...prev, tourName: data.title };
        });

        setInputVal((prev) => {
          return { ...prev, hazine: data.mainprice };
        });
        setInputVal((prev) => {
          return { ...prev, mavaredZarur: data.essentials };
        });
      }
    };
    getInfo().then(() => {
      setIsLoading(false);
    });
  }, []);

  const changeHandlerImg = (e) => {
    setAttrac({ ...attrac, [e.target.name]: e.target.files[0] });
  };
  const inputRef = useRef();

  function handleChange(evt) {
    var value;
    if (evt.target.name == "tourName" || evt.target.name == "mavaredZarur" || evt.target.name == "mavaredZarur") {
      value = evt.target.value;
    } else {
      value = removeCommas(evt.target.value);
    }
    setInputVal({
      ...inputVal,
      [evt.target.name]: value,
    });
  }
  const changeHandlerJazebe = (option) => {
    setValJazebe(option);
  };
  const changeHandlerlavazem = (option) => {
    setValLavazem(option);
  };
  const changeHandlerSakhti = (e) => {
    setSakhti(e.target.value);
  };
  const changeHandlerVaziat = (e) => {
    setVaziat(e.target.value);
  };
  const changeHandlerLeader = (e) => {
    setNameLeader(e.target.value);
  };
  const changeHandlerCities = (newValue, { action }) => {
    if (action == "create-option") {
      return setNameCities({ value: -1, label: newValue.label });
    }

    setNameCities(newValue);
  };
  const animatedComponents = makeAnimated();
  function AnimatedMulti() {
    return <CreatableSelect closeMenuOnSelect={false} components={animatedComponents} className={styles.filterSelect} isMulti options={allJazebe} value={valJazebe} onChange={changeHandlerJazebe} />;
  }

  return (
    <div className={styles.container} id="specification">
      {isLoading && <Loader></Loader>}

      <div className={`mt-2 d-flex justify-content-lg-around justify-content-md-end justify-content-sx-center ${styles.mainForm}`}>
        <div className={styles.formInput}>
          <p className="textDateBox"> زمان پایان </p>
          <div className="boxDate">
            <DatePicker className="rmdp-prime" showOtherDays calendar={persian} locale={persian_fa} calendarPosition="bottom-right" value={valueDatePayan} onChange={(date) => setValueDatePayan(date)} />
          </div>
        </div>
        <div className={styles.formInput}>
          <p className="textDateBox"> زمان شروع </p>
          <div className="boxDate">
            <DatePicker
              className="rmdp-prime"
              showOtherDays
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              value={valueDateStart}
              onChange={(value) => {
                setValueDateStart(value);
              }}
            />
          </div>
        </div>
        <div className={styles.formInput}>
          <p className="textBox"> نام تور</p>
          <input type="text" value={inputVal.tourName} onChange={handleChange} name="tourName" className={styles.inputBox} />
        </div>
        <div className={styles.formInput}>
          <label className="textBox" htmlFor="prices">
            هزینه
          </label>
          <input type="text" name="hazine" id="prices" value={addCommas(inputVal.hazine)} onChange={handleChange} className={styles.inputBox} />
        </div>

        <div className={styles.formInput}>
          <p className="textBox"> نام تور لیدر</p>
          <select class="form-select form-select-sm" aria-label=".form-select-sm example" className="inputBoxSelect" value={nameLeader} onChange={changeHandlerLeader}>
            {allLeader?.map((value, index) => (
              <option key={index} value={value.value}>
                {value.fname} {value.lname}
              </option>
            ))}
          </select>
        </div>

        <div className={styles.formInput}>
          <p className="textBox"> درجه سختی</p>
          <select class="form-select form-select-sm" aria-label=".form-select-sm example" className="inputBoxSelect" value={sakhti} onChange={changeHandlerSakhti}>
            <option selected hidden disabled value="-2" className={styles.selected}>
              لطفا گزینه ای را انتخاب کنید
            </option>
            <option className="It" value="1">
              1
            </option>
            <option className="It" value="2">
              2
            </option>
            <option className="It" value="3">
              3
            </option>
            <option className="It" value="4">
              4
            </option>
            <option className="It" value="5">
              5
            </option>
          </select>
        </div>
        <div className={styles.formInput}>
          <p className="textBox"> جاذبه ها</p>
          {AnimatedMulti()}
        </div>
        <div className={styles.formInput}>
          <p className="textBox"> دسته بندی</p>
          <CreatableSelect value={catValue} onChange={changeHandlerDaste} closeMenuOnSelect={false} components={animatedComponents} className={styles.filterSelect} isMulti options={allOptions} />
        </div>
        <div className={`d-flex justify-self-md-end ${styles.formInput}`}>
          <p className="textBox"> لوازم ضروری</p>
          <CreatableSelect closeMenuOnSelect={false} components={animatedComponents} className={styles.filterSelect} isMulti options={allAccessories} value={valLavazem} onChange={changeHandlerlavazem} />
        </div>
        <div className={` ${styles.formInput}`}>
          <p className="textBox"> موارد ضروری</p>
          <textarea type="text" name="mavaredZarur" value={inputVal.mavaredZarur} onChange={handleChange} className={styles.inputBoxbig}></textarea>
        </div>
        <div className={styles.formInput}>
          <p className="textBox"> عکس تور</p>
          <div className="inputimage_edit positionedit">
            <div>
              <input onChange={changeHandlerImg} ref={inputRef} name="pic" className={`form-control ${styles.formi}`} type="file" id="img_edit" accept="image/*" />
            </div>
          </div>
        </div>
        <div className={styles.formInput}>
          <p className="textBox"> شهر مقصد</p>
          <CreatableSelect closeMenuOnSelect={true} components={animatedComponents} className={styles.filterSelect} isMulti={false} options={allCities} value={nameCities} onChange={changeHandlerCities} />
        </div>
        <div className={styles.formInput}>
          <p className="textBox"> وضعیت تور</p>
          <select class="form-select form-select-sm" className="inputBoxSelect" value={vaziat} onChange={changeHandlerVaziat}>
            <option selected hidden disabled value="-1" className={styles.selected}>
              انتخاب کنید
            </option>
            <option className="It" value="0">
              در حال برنامه ریزی
            </option>
            <option className="It" value="1">
              در حال اجرا
            </option>
            <option className="It" value="2">
              اجرا شده
            </option>
            <option className="It" value="3">
              اجرا نشده
            </option>
            <option className="It" value="4">
              در حال رزرو
            </option>
          </select>
        </div>
        <div className={styles.formBoxss}>
          <div className={styles.formChecked3}>
            <label className="textRez" for="flexCheckDefault6">
              بیمه
            </label>
            <div className={styles.checkBox3}>
              <div class="form-check">
                <input className={`form-check-input ${styles.check2}`} type="checkbox" value="" checked={checkedBime} onChange={(e) => setCheckedBime(e.target.checked)} id="flexCheckDefault6" />
              </div>
            </div>
          </div>
          <div className={styles.formChecked3}>
            <label className="textRez" for="flexCheckDefault5">
              ویزا
            </label>
            <div className={styles.checkBox3}>
              <div class="form-check">
                <input className={`form-check-input ${styles.check2}`} type="checkbox" value="" checked={checkedVisa} onChange={(e) => setCheckedVisa(e.target.checked)} id="flexCheckDefault5" />
              </div>
            </div>
          </div>
          <div className={styles.formCheckedVije}>
            <label className="textRez2" for="flexCheckDefault4">
              تور ویژه
            </label>
            <div className={styles.checkBox3}>
              <div class="form-check">
                <input className={`form-check-input ${styles.check2}`} type="checkbox" value="" checked={checkedVije} onChange={(e) => setCheckedVije(e.target.checked)} id="flexCheckDefault4" />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.formBox2}>
          <div className={styles.formChecked}>
            <p className="textRez"> نوع سفر</p>
            <div className={styles.checkBox}>
              <div class="form-check">
                <input
                  className={`form-check-input ${styles.check}`}
                  type="checkbox"
                  value="havai"
                  checked={checkIt.havai}
                  // onChange={checkHandler}
                  onChange={() => setCheckIt({ ...checkIt, havai: !checkIt.havai })}
                  id="flexCheckDefault1"
                />
                <label class="form-check-label" for="flexCheckDefault1">
                  هوایی
                </label>
              </div>
              <div class="form-check">
                <input
                  className={`form-check-input ${styles.check}`}
                  type="checkbox"
                  value="zamini"
                  checked={checkIt.zamini}
                  // onChange={checkHandler}
                  onChange={() => setCheckIt({ ...checkIt, zamini: !checkIt.zamini })}
                  id="flexCheckChecked2"
                />
                <label class="form-check-label" for="flexCheckChecked2">
                  زمینی
                </label>
              </div>
              <div class="form-check">
                <input
                  className={`form-check-input ${styles.check}`}
                  type="checkbox"
                  value="reili"
                  checked={checkIt.reili}
                  // onChange={checkHandler}
                  onChange={() => setCheckIt({ ...checkIt, reili: !checkIt.reili })}
                  id="flexCheckDefault3"
                />
                <label class="form-check-label" for="flexCheckDefault3">
                  ریلی
                </label>
              </div>
            </div>
          </div>
        </div>

        <div
          className=" w-100 d-flex   justify-content-lg-start 
        justify-content-md-start justify-content-sm-center"
        >
          <div className={styles.mainFormTodo}>
            <TodoApp todos2={todos2} setTodos2={setTodos2} />
            <p className="textCost"> هرینه مازاد</p>
          </div>
        </div>
        <div
          className=" w-100 d-flex   justify-content-lg-start 
        justify-content-md-start justify-content-sm-center"
        >
          <div className={styles.mainFormTodoRez}>
            <ResrvApp todos={todos} setTodos={setTodos} allUserTag={allUserTag} />
            <p className="textCost"> رزرو</p>
          </div>
        </div>
      </div>
    </div>
  );
});

export default MainPage;
